__webpack_require__.p = "/nap-gpt/";